
import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { AuthServiceProvider } from '../../api/auth'

const AuthService = AuthServiceProvider()
const name = 'syncAccounts'

export default () => (asyncAction(
  name,
  AuthService.syncAccounts
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/auth/syncAccounts.js